var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/typography.scss';
import { TypographyLevel } from './TypographyLevel';
const typeToTag = {
    [TypographyLevel.BodyXs]: 'span',
    [TypographyLevel.BodySm]: 'span',
    [TypographyLevel.BodyMd]: 'span',
    [TypographyLevel.BodyLg]: 'span',
    [TypographyLevel.Paragraph]: 'p'
};
export const Typography = (_a) => {
    var { ref, children, className = '', level = TypographyLevel.BodyMd, noWrap = false } = _a, restProps = __rest(_a, ["ref", "children", "className", "level", "noWrap"]);
    const Tag = typeToTag[level];
    const typographyClassNames = ['typography', `typography-${level}`, noWrap ? 'typography-nowrap' : '', className];
    const typographyClassName = typographyClassNames.filter(Boolean).join(' ');
    return (_jsx(Tag, Object.assign({ ref: ref, className: typographyClassName }, restProps, { children: children })));
};
